import { Form, Formik } from "formik";
import React from "react";
import Dropzone from "react-dropzone";
import Modal from "react-modal";

import { UploadDropzone } from "../../../components/icons";
import CloseModal from "../../../components/icons/CloseModal";

const UploadCSVModal = (props) => {
  const { csvmodalIsOpen, closeCSVModal, loader, url, onFileDrop } = props;

  return (
    <Modal
      isOpen={csvmodalIsOpen}
      onRequestClose={closeCSVModal}
      shouldCloseOnOverlayClick={false}
      contentLabel="Filter Modal"
      portalClassName="react-modal"
      overlayClassName="modal"
      className="modal-dialog react-modal-dialog-sm modal-dialog-centered"
    >
      <Formik enableReinitialize>
        {({ errors, touched, setFieldValue, values }) => (
          <div className="modal-content">
            <Form>
              <div className="react-modal-header">
                <h5 className="react-modal-title">Upload CSV</h5>
                <button type="button" onClick={closeCSVModal} className="btn btn__default">
                  <CloseModal />
                </button>
              </div>
              <div className="react-modal-body">
                <div className="form-container">
                  <Dropzone
                    accept="text/*"
                    onDrop={(acceptedFiles) => {
                      onFileDrop(acceptedFiles);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone">
                        <div className="dropzone-inner" {...getRootProps()}>
                          <input
                            {...getInputProps()}
                            // type="file"
                            // accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          />
                          <div className="dropzone-icon">
                            <UploadDropzone />
                          </div>
                          <div className="dropzone-title">Upload a File</div>
                          <div className="dropzone-subtitle">Upload a CSV File</div>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              </div>
              <div className="react-modal-footer justify-content-center">
                <div className="react-foo-container">
                  <div className="right-btn-block">
                    <a href={url} className="btn-text">
                      Download Sample
                    </a>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        )}
      </Formik>
    </Modal>
  );
};

export default UploadCSVModal;
